var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#5222ff;}.b{fill:#fff;}.c,.e{stroke:none;}.e{fill:#5222ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-740 -1620)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(740 1620)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 30,
    cy: 30,
    r: 29.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(754 1634)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 16,
    cy: 16,
    r: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(766 1624)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(779.536 1625.483) rotate(30)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(790.517 1633.536) rotate(60)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(796 1646) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(766 1668)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(757.536 1663.589) rotate(30)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(752.412 1655.536) rotate(60)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(752 1646) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(756.412 1637.536) rotate(120)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(764.464 1632.411) rotate(150)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4,
    cy: 4,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(772.297 1664.444) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M 13.60260009765625 21.4999942779541 L 1.397420525550842 21.4999942779541 C 1.234070420265198 21.4999942779541 1.085870504379272 21.42381477355957 0.9908104538917542 21.29097366333008 C 0.8957504630088806 21.15813446044922 0.871460497379303 20.9932746887207 0.9241604804992676 20.83866500854492 L 7.026750564575195 2.937774658203125 C 7.133870601654053 2.62352466583252 7.416060447692871 2.599104642868042 7.500000476837158 2.599104642868042 C 7.583930492401123 2.599104642868042 7.866120338439941 2.62352466583252 7.973260402679443 2.937774658203125 L 14.07583045959473 20.83866500854492 C 14.1285400390625 20.99325370788574 14.10424041748047 21.15810394287109 14.00917053222656 21.29095458984375 C 13.91411018371582 21.42380523681641 13.76591014862061 21.4999942779541 13.60260009765625 21.4999942779541 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 7.500000476837158 3.099103927612305 L 1.397420883178711 20.9999942779541 L 13.60258007049561 20.9999942779541 L 7.500000476837158 3.099103927612305 M 7.499996662139893 2.099102020263672 C 7.896283149719238 2.099102020263672 8.292570114135742 2.324878692626953 8.446510314941406 2.776433944702148 L 14.54909038543701 20.67732429504395 C 14.7702465057373 21.32604598999023 14.28794956207275 21.9999942779541 13.60259628295898 21.9999942779541 C 13.60255432128906 21.9999942779541 13.60262203216553 21.9999942779541 13.60258007049561 21.9999942779541 L 1.397420883178711 21.9999942779541 C 0.712000846862793 22.00000381469727 0.2297401428222656 21.32608413696289 0.4509105682373047 20.67732429504395 L 6.55349063873291 2.776433944702148 C 6.707425117492676 2.324878692626953 7.103710651397705 2.099102020263672 7.499996662139893 2.099102020263672 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialler);
export default __webpack_public_path__ + "static/media/Dialler.92799b4cf528c8f146594ef8adc15a52.svg";
export { ForwardRef as ReactComponent };